import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";
import {
  findTicketByCode,
  statsTickets,
  ticketsInterventions,
} from "../../_App/Redux/Slices/tickets/ticketSlice";
import Ticket from "../Tickets/Ticket";
import FicheInterventionModal from "../Interventions/FicheInterventionModal";
import { Form, Button } from "react-bootstrap";
import * as XLSX from "xlsx"; // Import xlsx

const TicketsInterventions = ({ setMergedData }: any) => {
  const TicketsInterventions = useAppSelector(ticketsInterventions);
  const dispatch = useAppDispatch();

  const [currentPage, setCurrentPage] = useState(1);
  const ticketsPerPage = 15;
  const [searchTerm, setSearchTerm] = useState("");

  const filteredData = TicketsInterventions.filter(
    (item: any) =>
      item.machine_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.type?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.odf_code?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.groupe?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.objet?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.utilisateur?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const indexOfLastTicket = currentPage * ticketsPerPage;
  const indexOfFirstTicket = indexOfLastTicket - ticketsPerPage;
  const currentTickets = filteredData.slice(
    indexOfFirstTicket,
    indexOfLastTicket,
  );
  const totalPages = Math.ceil(filteredData.length / ticketsPerPage);

  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const [ShowModal, setShowModal] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState();
  const [ticket, setTicket] = useState(undefined);
  const [showIntervention, setShowIntervention] = useState(false);
  const [selectedIntervention, setSelectedIntervention] = useState(undefined);

  useEffect(() => {
    const fetch = async () => {
      if (selectedTicket) {
        const res = await dispatch(findTicketByCode(selectedTicket));
        if (res.payload) {
          setTicket(res.payload);
        }
      }
    };
    fetch();
  }, [selectedTicket, dispatch]);

  const exportToExcel = () => {
    const dataToExport = filteredData.map((ticket: any) => ({
      Ticket: ticket.ticket_code,
      Type: ticket.type,
      objet: ticket.objet,
      description: ticket.description,
      machine_code: ticket.machine_code,
      odf_code: ticket.odf_code,
      stampo: ticket.Stampo,

      date: ticket.date.replace("T", " ").split(".")[0],
      groupe: ticket.groupe,
      objet_intervention: ticket.objet_intervention,

      commentaire: ticket.commentaire,
      utilisateur: ticket.utilisateur,
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Tickets");
    XLSX.writeFile(workbook, "Tickets_interventions.xlsx");
  };

  return (
    <>
      <Ticket
        ShowModal={ShowModal}
        setShowModal={setShowModal}
        selectedTicket={ticket}
        setSelectedTicket={setSelectedTicket}
        setSelectedIntervention={setSelectedIntervention}
        setShowIntervention={setShowIntervention}
      />
      <FicheInterventionModal
        ShowModal={showIntervention}
        setShowModal={setShowIntervention}
        intervention={selectedIntervention}
        setIntervention={setSelectedIntervention}
      />
      <div
        className="row"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div className="col-10">
          {" "}
          <Form.Group controlId="formSearch">
            <Form.Control
              type="text"
              placeholder="Recherche par machine ou type ..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </Form.Group>
        </div>
        <div className="col-2">
          {" "}
          <Button
            variant="success"
            onClick={exportToExcel}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <i className="fas fa-file-excel mr-2"></i>
            Export
          </Button>
        </div>
      </div>

      <table id="style-3" className="table style-3 table-hover">
        <thead>
          <tr>
            <th>Ticket</th>
            <th>Type</th>
            <th>Objet</th>
            <th>Description</th>

            <th>ODP</th>
            <th>Stampo</th>

            <th>Machine</th>
            <th>Date</th>
            <th>Groupe</th>
            <th>Objet intervention</th>
            <th>Commentaire</th>
            <th>Techniciens</th>
          </tr>
        </thead>
        <tbody>
          {currentTickets.length > 0 ? (
            currentTickets.map((ticket: any, index: any) => (
              <tr key={index}>
                <td
                  onClick={() => {
                    setSelectedTicket(ticket.ticket_code);
                    setShowModal(true);
                  }}
                >
                  <a className="link" style={{ cursor: "pointer" }}>
                    {ticket.ticket_code}
                  </a>
                </td>
                <td>{ticket.type}</td>
                <td>{ticket.objet}</td>
                <td>{ticket.description}</td>

                <td>{ticket.odf_code}</td>
                <td>{ticket.Stampo}</td>

                <td>{ticket.machine_code}</td>
                <td>{ticket.date.replace("T", " ").split(".")[0]}</td>
                <td>{ticket.groupe}</td>
                <td>{ticket.objet_intervention}</td>
                <td>{ticket.commentaire}</td>
                <td>{ticket.utilisateur}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={10}>No data available</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="pagination" style={{ overflow: "auto", margin: "5px" }}>
        <button
          disabled={currentPage === 1}
          onClick={() => handlePageChange(currentPage - 1)}
          className="btn"
        >
          Préc.
        </button>

        {Array.from({ length: totalPages }, (_, i) => (
          <button
            key={i + 1}
            className={currentPage === i + 1 ? "btn active" : "btn"}
            onClick={() => handlePageChange(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          disabled={currentPage === totalPages}
          onClick={() => handlePageChange(currentPage + 1)}
          className="btn"
        >
          Suiv.
        </button>
      </div>
    </>
  );
};

export default TicketsInterventions;
